import React from 'react';
import { Form, SectionTitle } from 'ui-library';
import { requiredRule } from '../common/Rules';
import { ContentWrapper } from '../common/StyledComponents';
import { Select } from 'antd';
import range from 'lodash/range';
import { getTranslatedString } from 'helpers/i18n';

const mininumLeaseTerm = 1;
const maximumLeaseTermPlusOne = 49;

const options = range(mininumLeaseTerm, maximumLeaseTermPlusOne).map((i) => ({
  label: `${i} ${
    i > 1 ? getTranslatedString('monthsPlural') : getTranslatedString('monthSingular')
  }`,
  value: i,
}));

const ValidLeaseTerms = () => {
  return (
    <ContentWrapper>
      <SectionTitle>
        {getTranslatedString('landlordPortal.incentives.validLeaseTerms')}
      </SectionTitle>

      <Form.Item
        name="valid_lease_terms"
        label={getTranslatedString('landlordPortal.incentives.leaseTerms')}
        rules={[requiredRule]}
      >
        <Select mode="multiple" allowClear options={options} />
      </Form.Item>
    </ContentWrapper>
  );
};

export default ValidLeaseTerms;
